import { Slider } from "@/components/ui/slider";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { motion } from "framer-motion";

const inr = (v) => `₹ ${new Intl.NumberFormat("en-IN").format(Math.round(v || 0))}`;
export const compactINR = (v) => {
  const a = Math.abs(v || 0);
  if (a >= 1e7) return `₹${((v || 0) / 1e7).toFixed(2)} Cr`;
  if (a >= 1e5) return `₹${((v || 0) / 1e5).toFixed(2)} L`;
  return `₹${Math.round(v || 0).toLocaleString("en-IN")}`;
};

export const Field = ({ label, hint, children }) => (
  <div className="space-y-2">
    <div className="flex items-baseline justify-between gap-2">
      <Label className="text-sm font-semibold text-[#3A463F]">{label}</Label>
      {hint != null && <span className="text-sm font-mono font-semibold text-[#2D6A4F]">{hint}</span>}
    </div>
    {children}
  </div>
);

export const MoneyInput = ({ value, onChange, testid, helper }) => (
  <div>
    <div className="relative">
      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[#8A9790] font-semibold">₹</span>
      <Input
        data-testid={testid}
        type="number"
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        className="pl-7 font-mono h-11 bg-[#FBF9F5] border-[#E8E3D9]"
      />
    </div>
    {helper && <p className="text-xs text-[#8A9790] mt-1">{helper}</p>}
  </div>
);

export const NumberInput = ({ value, onChange, testid, suffix, helper }) => (
  <div>
    <div className="relative">
      <Input
        data-testid={testid}
        type="number"
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        className="font-mono h-11 bg-[#FBF9F5] border-[#E8E3D9] pr-10"
      />
      {suffix && <span className="absolute right-3 top-1/2 -translate-y-1/2 text-[#8A9790] text-sm">{suffix}</span>}
    </div>
    {helper && <p className="text-xs text-[#8A9790] mt-1">{helper}</p>}
  </div>
);

export const SliderRow = ({ value, min, max, step = 1, onChange, testid, suffix }) => (
  <div className="flex items-center gap-4">
    <Slider data-testid={testid} value={[value]} min={min} max={max} step={step}
      onValueChange={(v) => onChange(v[0])} className="flex-1" />
    <span className="w-16 text-right font-mono text-sm text-[#1A231F]">{value}{suffix}</span>
  </div>
);

export const Segmented = ({ options, value, onChange, testid, layoutId }) => (
  <div className="grid gap-2 rounded-xl bg-[#F5F2EB] p-1" style={{ gridTemplateColumns: `repeat(${options.length},minmax(0,1fr))` }} data-testid={testid}>
    {options.map((o) => {
      const key = o.value !== undefined ? o.value : o.id;
      const active = value === key;
      return (
        <button key={key} data-testid={`${testid}-${key}`} onClick={() => onChange(key)}
          className={`relative rounded-lg py-2 text-xs sm:text-sm font-semibold transition-colors duration-300 ${active ? "text-white" : "text-[#5C6A64]"}`}>
          {active && <motion.span layoutId={layoutId || testid} className="absolute inset-0 rounded-lg bg-[#2D6A4F]" transition={{ type: "spring", stiffness: 400, damping: 32 }} />}
          <span className="relative">{o.label}</span>
        </button>
      );
    })}
  </div>
);

export const SectionCard = ({ title, icon: Icon, children, className = "", testid }) => (
  <div data-testid={testid} className={`bg-white rounded-2xl border border-[#E8E3D9] p-5 sm:p-6 shadow-sm ${className}`}>
    {title && (
      <div className="flex items-center gap-2 mb-4">
        {Icon && <Icon className="h-4 w-4 text-[#2D6A4F]" />}
        <h3 className="font-heading text-lg font-bold text-[#1A231F]">{title}</h3>
      </div>
    )}
    {children}
  </div>
);

export const StatCard = ({ label, value, sub, accent = "#2D6A4F", testid, big }) => (
  <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}
    className="rounded-2xl p-5 text-white shadow-sm" style={{ background: accent }} data-testid={testid}>
    <div className="text-[11px] uppercase tracking-wider font-semibold text-white/70">{label}</div>
    <div className={`font-heading font-extrabold mt-1 ${big ? "text-3xl sm:text-4xl" : "text-2xl"}`}>{value}</div>
    {sub && <div className="text-xs text-white/70 mt-1">{sub}</div>}
  </motion.div>
);

export const InfoRow = ({ label, value, strong }) => (
  <div className="flex items-center justify-between py-2 border-b border-[#F0ECE3] last:border-0">
    <span className="text-sm text-[#5C6A64]">{label}</span>
    <span className={`font-mono text-sm ${strong ? "font-bold text-[#1A231F]" : "text-[#3A463F]"}`}>{value}</span>
  </div>
);

export { inr };
